export const stats = [
  { id: 1, label: "Finished\nProjects", value: 8 },
  { id: 2, label: "Years\nExperience", value: 2 },
  { id: 3, label: "Game Jams\nCompleted", value: 5 },
];